/**
 * https:www.notion.so/faire/FD-Landing-Pages-Redesign-XPs-6c8349b8e3a04fe8b473c3c02f1665e7
 */
export const FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827 = 'FAIRE_DIRECT_LANDING_PAGE_REDESIGN_BRAND_SUMMARY_240827';
